import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'actions';

class OpposingGoalie extends Component {
    onClick(isChecked) {
        this.props.dispatch(Action.do('useOpposingGoalie', isChecked));
    }

    render() {
        const {lineupsFilter} = this.props;
        const isChecked = lineupsFilter.opposingPlayers === null;

        return (
            <div>
                <div className="checkbox">
                    <label>
                        <input type="checkbox" checked={isChecked} onChange={(e) => ::this.onClick(e.target.checked)} />
                        Allow skaters vs opposing goalie
                    </label>
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {filters: lineupsFilter} = state.lineupsData;
    return {
        lineupsFilter,
    };
}

export default connect(mapStatesToProps)(OpposingGoalie);
